<div class="lcl-booking-hazard-disclaimer" [formGroup]="formGroup">
  <div class="custom-control custom-checkbox col-9">
    <app-control-wrapper [control]="formGroup.get('noHazardousGoodsClaimed')" [errors]="errors" [isShowHelper]="false">
      <div control-wrapper>
        <input
          type="checkbox"
          class="custom-control-input"
          id="hazard-disclaimer"
          [formControl]="formGroup.get('noHazardousGoodsClaimed')"
        />
        <label class="custom-control-label lcl-booking-hazard-disclaimer-label" for="hazard-disclaimer">
          {{ "LCL_SHIPMENT.BOOKING.HAZARD_DISCLAIMER" | translate }}
        </label>
      </div>
    </app-control-wrapper>
  </div>
  <div class="lcl-booking-hazard-disclaimer-icon">
    <span class="icon-ic_big_a"></span>
  </div>
</div>
